export const WHITE = '#fff'
export const PRIMARY = '#150F3B'
export const BLUE_LIGHT = '#e7e8ec'
